// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2oqp6","checkboxCol":"Table_checkboxCol__3VF3g","emailCol":"Table_emailCol__2cwsp","actionCol":"Table_actionCol__2JShB"};